"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.generateTokenFn = generateTokenFn;
exports.resolveFallbacks = resolveFallbacks;
exports.resolveTargets = resolveTargets;
exports.resolveTextStyleValue = resolveTextStyleValue;
exports.resolveTokenStyleValue = resolveTokenStyleValue;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _lodash = require("lodash");

function resolveTargets(_ref) {
  var _context, _context2, _context3, _context4;

  var token = _ref.token,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? null : _ref$base,
      target = _ref.target,
      type = _ref.type;
  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var targets = (0, _reverse.default)(_context = (0, _filter.default)(_context2 = (0, _lodash.isArray)(target) ? (0, _toConsumableArray2.default)(target) : [target]).call(_context2, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context);
  var types = (0, _reverse.default)(_context3 = (0, _filter.default)(_context4 = (0, _lodash.isArray)(type) ? (0, _toConsumableArray2.default)(type) : [type]).call(_context4, function (t) {
    return t !== null && t !== void 0 ? t : false;
  })).call(_context3);
  return (0, _reduce.default)(targets).call(targets, function (acc, target) {
    return (0, _reduce.default)(types).call(types, function (acc, type) {
      var _context5;

      return token((0, _concat.default)(_context5 = "".concat(target, ".")).call(_context5, type), acc);
    }, acc);
  }, base);
}

function resolveTokenStyleValue(_ref2) {
  var token = _ref2.token,
      tokenKey = _ref2.tokenKey,
      value = _ref2.value;

  if ((0, _lodash.isString)(value)) {
    var _context6;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token((0, _concat.default)(_context6 = "".concat(tokenKey, ".")).call(_context6, value));
  } else if ((0, _lodash.isFunction)(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}

function resolveTextStyleValue(_ref3) {
  var token = _ref3.token,
      type = _ref3.type,
      tokenKey = _ref3.tokenKey,
      value = _ref3.value;

  if ((0, _lodash.isString)(value)) {
    var _context7, _context8;

    // Assume if the user passes a string to
    // these fallbacks they want a value
    // from the base tokens
    return token((0, _concat.default)(_context7 = (0, _concat.default)(_context8 = "".concat(tokenKey, ".")).call(_context8, value, ".")).call(_context7, type));
  } else if ((0, _lodash.isFunction)(value)) {
    // Otherwise return whatever value they decide
    return value({
      token: token
    });
  }
}

function resolveFallbacks(_ref4) {
  var _context9, _context10;

  var token = _ref4.token,
      type = _ref4.type,
      _ref4$base = _ref4.base,
      base = _ref4$base === void 0 ? null : _ref4$base,
      fallback = _ref4.fallback,
      tokenKey = _ref4.tokenKey,
      resolver = _ref4.resolver;
  // Filter out undefined or null and reverse
  // order beacuse we're working inside out
  var fallbacks = (0, _reverse.default)(_context9 = (0, _filter.default)(_context10 = (0, _lodash.isArray)(fallback) ? (0, _toConsumableArray2.default)(fallback) : [fallback]).call(_context10, function (f) {
    return f !== null && f !== void 0 ? f : false;
  })).call(_context9);
  return (0, _reduce.default)(fallbacks).call(fallbacks, function (acc, fallback) {
    var _resolver;

    return (_resolver = resolver({
      token: token,
      type: type,
      tokenKey: tokenKey,
      value: fallback
    })) !== null && _resolver !== void 0 ? _resolver : acc;
  }, resolver({
    token: token,
    type: type,
    tokenKey: tokenKey,
    value: base
  }));
}

function generateTokenFn(_ref5) {
  var target = _ref5.target,
      base = _ref5.base,
      type = _ref5.type,
      fallback = _ref5.fallback,
      tokenKey = _ref5.tokenKey,
      _ref5$resolver = _ref5.resolver,
      resolver = _ref5$resolver === void 0 ? resolveTokenStyleValue : _ref5$resolver;
  return function (_ref6) {
    var token = _ref6.token;
    return resolveTargets({
      token: token,
      target: target,
      type: type,
      base: resolveFallbacks({
        token: token,
        type: type,
        base: base,
        fallback: fallback,
        tokenKey: tokenKey,
        resolver: resolver
      })
    });
  };
}